export interface MapColors {
	base: string;
	selected: string;
	border: string;
	hover: string;
	labelOnSelected: string;
	labelOnBase: string;
	labelHaloSelected: string;
	labelHaloBase: string;
}

const FALLBACKS: MapColors = {
	base: '#c7ceff',
	selected: '#453af1',
	border: 'rgba(255,255,255,0.85)',
	hover: '#7b72f5',
	labelOnSelected: '#ffffff',
	labelOnBase: '#453af1',
	labelHaloSelected: 'rgba(69,58,241,0.35)',
	labelHaloBase: 'rgba(255,255,255,0.9)',
};

function readVar(name: string, fallback: string): string {
	if (typeof document === 'undefined') return fallback;
	const val = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
	return val || fallback;
}

export function getMapColors(): MapColors {
	return {
		base: readVar('--params-map-state-base', FALLBACKS.base),
		selected: readVar('--params-map-state-selected', FALLBACKS.selected),
		border: readVar('--params-map-border', FALLBACKS.border),
		hover: readVar('--params-map-state-hover', FALLBACKS.hover),
		labelOnSelected: readVar('--params-map-label-on-selected', FALLBACKS.labelOnSelected),
		labelOnBase: readVar('--params-map-label-on-base', FALLBACKS.labelOnBase),
		labelHaloSelected: readVar('--params-map-label-halo-selected', FALLBACKS.labelHaloSelected),
		labelHaloBase: readVar('--params-map-label-halo-base', FALLBACKS.labelHaloBase),
	};
}
